import { Box } from '@mui/material';

export interface CellProps {
  children: React.ReactNode;
  centered?: boolean;
  end?: boolean;
}

export const Cell = ({ children, centered = false, end = false }: CellProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={centered ? 'center' : end ? 'flex-end' : 'flex-start'}
      height="100%"
    >
      {children}
    </Box>
  );
};
